import { type ReactNode } from 'react';
import { Link } from 'react-router';
import styles from './LegalLayout.module.css';
import { usePageTitle } from '../hooks/usePageTitle';

interface LegalLayoutProps {
  title: string;
  /** ISO date (YYYY-MM-DD) shown in the header. */
  lastUpdated: string;
  children: ReactNode;
}

/** Shared chrome for /privacy, /terms, /imprint. Keeps typography + footer nav consistent. */
export function LegalLayout({ title, lastUpdated, children }: LegalLayoutProps) {
  usePageTitle(`${title} — Markcat`);
  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <div className={styles.header}>
          <Link to="/" className={styles.brand}>Markcat</Link>
          <Link to="/" className={styles.home}>← Back to home</Link>
        </div>

        <h1 className={styles.title}>{title}</h1>
        <p className={styles.lastUpdated}>Last updated: {lastUpdated}</p>

        <div className={styles.body}>{children}</div>

        <div className={styles.footer}>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/imprint">Imprint</Link>
        </div>
      </div>
    </div>
  );
}
